import React, { useRef, useImperativeHandle } from "react";
import "./input.css";

const Input = React.forwardRef((props, ref) => {
  const inputRef = useRef();

  const activated = () => {
    inputRef.current.focus();
  };

  const returnVal = () => {
    return inputRef.current.value;
  };

  const addClassName = (class_name) => {
    inputRef.current.className = class_name;
  };

  useImperativeHandle(ref, () => ({
    focus: activated,
    val: returnVal,
    addClassName: addClassName,
    // Expose scrollIntoView so that Create.jsx can call it
    scrollIntoView: (options) => {
      inputRef.current.scrollIntoView(options);
    }
  }));

  return (
    <>
      <input
        ref={inputRef}
        type={props?.type}
        onChange={props?.onChange}
        onBlur={props?.onBlur}
        onKeyUp={props?.onKeyUp}
        placeholder={props?.placeholder}
        className={props?.inputClass}
        maxLength={props?.maxLength}
        value={props?.value}
        autoFocus={props?.autoFocus}
      />
    </>
  );
});

export default Input;
